export const APP_PALETTE = {
  background: "#ebe9e4",
  surface: "#f7f5f1",
  text: {
    primary: "#2b2539",
    secondary: "#3f384e",
    muted: "#7a7289",
  },
  brand: {
    primary: "#1e3a5f",
    primaryHover: "#162d4a",
    secondary: "#efc8c8",
    secondaryHover: "#deb5b5",
    soft: "#dde6f0",
    borderSoft: "#cfc8c1",
  },
  status: {
    success: "#4f9182",
    warning: "#b7a34e",
    error: "#cf7886",
    info: "#1e3a5f",
    delivery: "#7b6767",
    neutral: "#5e566f",
  },
  surfaces: {
    subtle: "#f1efeb",
    subtleAlt: "#ebe9e4",
    warningSoft: "#f4f4de",
    successSoft: "#dfece7",
    errorSoft: "#f5e4e4",
    infoSoft: "#dde6f0",
    brandSoft: "#eeefc8",
    brandBorderSoft: "#d4cdc5",
    border: "#d4cdc5",
    borderSoft: "#e2ddd6",
  },
};

export const APP_THEME = {
  background: APP_PALETTE.background,
  surface: APP_PALETTE.surface,
  textPrimary: APP_PALETTE.text.primary,
  textSecondary: APP_PALETTE.text.secondary,
  textMuted: APP_PALETTE.text.muted,
  primary: APP_PALETTE.brand.primary,
  primaryHover: APP_PALETTE.brand.primaryHover,
  secondary: APP_PALETTE.brand.secondary,
  secondaryHover: APP_PALETTE.brand.secondaryHover,
  success: APP_PALETTE.status.success,
  warning: APP_PALETTE.status.warning,
  error: APP_PALETTE.status.error,
  info: APP_PALETTE.status.info,
  delivery: APP_PALETTE.status.delivery,
  neutral: APP_PALETTE.status.neutral,
  soft: APP_PALETTE.brand.soft,
  border: APP_PALETTE.surfaces.border,
  borderSoft: APP_PALETTE.surfaces.borderSoft,
};